import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
	setInitialLoginState,
	loginUser,
} from '../../../redux/userAuthentication/userAuth.actions';
import Analytics from '../../../utils/Analytics';
import { trimText, isValidLoginId } from '../../../utils/commonFunctions';
import { setErrorPanel } from '../../../redux/utilities/utils.actions';

class signInButton extends React.Component {
	constructor(props) {
		super(props);
		this.validateName = this.validateName.bind(this);
		this.validatePin = this.validatePin.bind(this);
		this.validateDetails = this.validateDetails.bind(this);
	}

	validateDetails = () => {
		const { loginUser } = this.props;
		let isValidLoginId = this.validateName();

		if (isValidLoginId) {
			if (this.validatePin()) {
				loginUser();
			}
		}
	};
	validateName = () => {
		let { loginId, setErrorPanel, updateState } = this.props;

		let panelClass = '';
		loginId = trimText(loginId);
		let panelMsg = isValidLoginId(loginId);
		localStorage.setItem('loginId', loginId);
		updateState({
			panelMsg,
			panelClass,
		});
		if (panelMsg.length > 0) {
			setErrorPanel({
				panelClass: 'alert alert-danger',
				panelMsg,
			});
			return false;
		}

		return true;
	};

	validatePin = () => {
		const { pin, loginId, setErrorPanel } = this.props;
		if (pin === '') {
			setErrorPanel({
				panelClass: 'alert alert-danger',
				panelMsg: 'Please enter pin',
			});
		} else {
			Analytics('loginButtonClick', {
				screen: this.props.signInText === 'LOG IN' ? 'login' : 'verifyuser',
				action: 'Clicking the login button',
				info: { user_name: loginId },
			});
		}
		return !!pin;
	};

	render() {
		let { signInText } = this.props;
		return (
			<>
				<button
					aria-label="signin"
					id="loginBtn"
					type="button"
					className="btn-step-signin btn-primary"
					onClick={this.validateDetails}
				>
					{signInText}
				</button>
			</>
		);
	}
}

const mapStateToProps = (state) => {
	const { pin, loginId } = state.rootReducer.loginDetails;
	return {
		pin,
		loginId,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setErrorPanel: (errorText) => dispatch(setErrorPanel(errorText)),
		updateState: (value) => dispatch(setInitialLoginState(value)),
		loginUser: () => dispatch(loginUser()),
	};
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
	signInButton,
);
